class BirdsnestTVSlider {
    constructor(container) {
        this.container = container;
        this.items = container.querySelectorAll('[data-birdsnest-tv-item]');
        if (this.items.length <= 1) return;
        this.init();
    }

    init() {
        const needsSlider = this.checkIfNeedsSlider();
        
        this.flkty = new window.theme.Flickity(this.container, {
        wrapAround: needsSlider,
        pageDots: false,
        prevNextButtons: true,
        adaptiveHeight: true,
        cellAlign: 'left',
        contain: false,
        freeScroll: false
        });

        // Position arrows once Flickity is ready
        this.flkty.on('ready', () => {
            this.setSliderArrowsPosition();
        });

        this.handleAccessibility();
        this.handleResize();

        // initial positioning
        this.setSliderArrowsPosition();
    }

    checkIfNeedsSlider() {
        let totalItemsWidth = 0;
        this.items.forEach(item => {
            totalItemsWidth += item.offsetWidth;
        });
        
        const containerWidth = this.container.offsetWidth;
        
        return totalItemsWidth > containerWidth;
    }

    handleResize() {
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                if (this.flkty) {
                    this.flkty.resize();
                }
                this.setSliderArrowsPosition();
            }, 250);
        });
    }

    setSliderArrowsPosition() {
        const prevButton = this.container.querySelector('.flickity-button.previous');
        const nextButton = this.container.querySelector('.flickity-button.next');

        if (!prevButton || !nextButton) return;

        const top = (this.container.offsetHeight / 2) + 'px';
        prevButton.style.top = top;
        nextButton.style.top = top;

    }

    handleAccessibility() {
        this.flkty.on('ready', () => {
        this.updateTabIndex(this.flkty.selectedIndex);
        });

        this.flkty.on('change', (index) => {
        this.updateTabIndex(index);
        });
    }

    updateTabIndex(activeIndex) {
        this.flkty.cells.forEach((cell, index) => {
        const focusables = cell.element.querySelectorAll('a, button');
        focusables.forEach(el => {
            el.setAttribute('tabindex', index === activeIndex ? '0' : '-1');
        });
        });
    }
}
function initBirdsnestTVSlider(scope = document) {
  scope
    .querySelectorAll('[data-birdsnest-tv-slider]')
    .forEach(el => {
      if (el._birdsnestTV) return;
      el._birdsnestTV = new BirdsnestTVSlider(el);
    });
}
document.addEventListener('DOMContentLoaded', () => {
  initBirdsnestTVSlider();
});
document.addEventListener('shopify:section:load', (e) => {
  initBirdsnestTVSlider(e.target);
});